import { of } from 'rxjs';

import { actions } from '@ezugi/bootstrap';
import { uiActions } from '@ezugi/bootstrap/src/store/actions/ui';

const {
  gameActions: { game },
} = actions;

export default function handlePlaceYourBets() {
  return of(
    game.set({
      // Reset multipliers once PLACE_YOUR_BETS starts
      multipliers: {},
    }),
    // Reset progressBar
    uiActions.progressBar.reset()
  );
}
